// @ts-check
import { Flex, Padding } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Icon from 'components/base/Icon';
import { LBButton } from '@linearb/buzz';

const ExcludeBranchModal = ({
  isBranchExcluded,
  excludeBranch,
  includeBranch,
  close
}) => {
  const excludedBranchesData = isBranchExcluded
    ? {
        title: 'Cancel branch exclusion',
        content: `Cancel branch exclusion from all metrics`,
        saveFunction: includeBranch
      }
    : {
        title: 'Exclude Branch',
        content: `Exclude branch from all metrics`,
        saveFunction: excludeBranch
      };

  return (
    <Flex direction='column' padding='medium' justify='space-between'>
      <Flex pb='medium' items='center'>
        <Icon name='branch' size='normal' color='shuttleGray' />
        <Text size='x-x-large' color='black' pl='0.5rem'>
          {excludedBranchesData.title}
        </Text>
      </Flex>
      <Text size='medium' lineHeight='1.5' mb='2rem'>
        {excludedBranchesData.content}
      </Text>
      <Flex pt='normal' justify='flex-end'>
        <LBButton variant='outline' onClick={close}>
          Cancel
        </LBButton>
        <Padding l='small'>
          <LBButton onClick={excludedBranchesData.saveFunction}>Save</LBButton>
        </Padding>
      </Flex>
    </Flex>
  );
};

export default ExcludeBranchModal;
